import React, { memo } from 'react';
import Filters from 'components/utility/Filters';
import { ScrollView, Stack, useTheme, H1, Text, Theme } from 'tamagui';
import { Center } from 'components/base/General';
import { CatsModal as Categories } from 'components/utility/Categories';
import Breadcrumb from 'components/utility/Breadcrumb';
import {
  CategoryArticlesWrapper,
  RecentArticles,
} from 'components/cards/Articles';

interface TaxonProps {
  taxonId: string;
  title: string;
  initialCategoryArticles: any[];
  initialRecentArticles: any[];
  hideCalendar?: boolean;
  mainPage?: boolean;
}

const Taxon = ({
  taxonId,
  title,
  initialCategoryArticles,
  initialRecentArticles,
  hideCalendar,
  mainPage,
}: TaxonProps) => {
  const theme = useTheme() as Theme;

  return (
    <ScrollView minHeight={600} zIndex={10} bg={theme.background}>
      <Center py={15} $lg={{ py: 25 }} $xl={{ py: 25 }}>
        <H1
          bold
          fontSize="$4xl"
          $md={{
            fontSize: '$6xl',
          }}
          color={theme.mainColor.get()}
        >
          {title}
        </H1>
      </Center>
      <Breadcrumb />
      <Stack>
        <Filters hideCalendar={hideCalendar} />
      </Stack>

      <RecentArticles
        initialData={initialRecentArticles}
        taxonId={taxonId}
        mainPage={mainPage}
        title="Recent Articles"
      />
      <Stack alignItems="center" justifyContent="center">
        <Categories taxonId={taxonId} />
      </Stack>
      <CategoryArticlesWrapper
        initialData={initialCategoryArticles}
        taxonId={taxonId}
      />
      <Stack height={50} />
    </ScrollView>
  );
};

export default memo(Taxon);
